var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTotalLandArea = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.54,
  fillRule: "evenodd",
  d: "M2.112 5.554a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.54,
  fillRule: "evenodd",
  d: "m5.616 6.059 3.688.017-.005 1-1.97-.01 3.423 3.423-.706.706-3.423-3.423.01 1.97-1 .004zm12.991 0-.017 3.687-1-.005.01-1.969-3.423 3.423-.706-.707 3.423-3.422-1.97.01-.004-1zm-4.43 7.855 3.423 3.422-.01-1.97 1-.004.017 3.688-3.687-.018.005-.999 1.969.01-3.423-3.423zm-3.424.706L7.33 18.043l1.97-.01.004 1-3.688.017.018-3.688.999.005-.01 1.97 3.423-3.423z",
  clipRule: "evenodd"
})));
export default SvgTotalLandArea;